<template>
    <div class="vertify-container">
        <div class="vertify-wrap" v-if="visible">
            <Vertify @success="handleSuccess" slider-text="向右滑动验证" :offset="offsetValue" :imgs="localImages"></Vertify>
        </div>
    </div>
</template>

<script>
import Vertify from 'vue3-slide-verify'
import 'vue3-slide-verify/dist/style.css'

import CryptoJS from 'crypto-js'
import { get, post } from '../utils/request'
const localImages = [
    require('@/assets/slides/16.jpg'), 
    require('@/assets/slides/60.jpg'), 
    require('@/assets/slides/153.jpg'), 
    require('@/assets/slides/208.jpg'), 
    require('@/assets/slides/211.jpg'), 
    require('@/assets/slides/268.jpg'), 
    require('@/assets/slides/449.jpg'), 
    require('@/assets/slides/486.jpg'), 
    require('@/assets/slides/515.jpg'), 
    require('@/assets/slides/535.jpg'), 
    require('@/assets/slides/646.jpg'), 
    require('@/assets/slides/668.jpg'), 
    require('@/assets/slides/1047.jpg')
]

export default {
    components: { Vertify },
    data() {
        return {
            visible: false,
            offsetValue: 10,
            aesKey: '7Aj44umxnVRR7uZFJtx7RWks5k2uCuwN',
            localImages: localImages
        }
    },
    computed: {
        userInfo() {
            return this.$store.state.userInfo
        },
        categoryList() {
            return this.$store.state.categoryList
        },
        env() {
            return this.$store.state.env
        }
    },
    created() {
        this.fetchAndDecryptOffset()
    },
    mounted() {},
    methods: {
        onSuccess(result) {
            console.log(result)
        },
        async fetchAndDecryptOffset() {
            var res = await get('/common/verifyOffset')
            if (res.code == 0) {
                var data = res.data
                // 2.2 解密偏移量
                const decrypted = CryptoJS.AES.decrypt(data.offset, CryptoJS.enc.Utf8.parse(this.aesKey), {
                    iv: CryptoJS.enc.Base64.parse(data.iv),
                    mode: CryptoJS.mode.CBC,
                    padding: CryptoJS.pad.Pkcs7
                })
                const offset = parseInt(decrypted.toString(CryptoJS.enc.Utf8))
                if (isNaN(offset)) throw new Error('Decryption failed')

                // 2.3 更新组件的offset数据
                this.offsetValue = offset
                console.log(offset)
                this.visible = true
            }
        },
        handleSuccess(moveDistance) {
            // 4. 处理验证成功事件，moveDistance 是用户最终滑动的距离
            console.log('Verification successful, move distance:', moveDistance)
            this.$emit('verified', moveDistance) // 将滑动距离传递到父组件
        }
    }
}
</script>
<style scoped lang="scss">
.vertify-container {
    position: fixed;
    left: 0;
    top: 0;
    width: 100vw;
    height: 100vh;
    z-index: 200;
    background: rgba(0, 0, 0, 0.5);
    .vertify-wrap {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        background-color: #fff;
    }
}
</style>
<style lang="scss">
.slide-verify-slider-text {
    font-size: 0.2rem !important;
}
.slide-verify-slider {
    margin-top: 0 !important;
}
</style>
